<h2 mat-dialog-title>{{ data.title }}</h2>
<div mat-dialog-content [innerHtml]="safeContent"></div>
<div mat-dialog-actions align="center">
  <button mat-flat-button class="m-2" color="primary" [mat-dialog-close]="true">{{ buttonText }}</button>
</div>